import { Component, OnDestroy } from "@angular/core";
import { ICellRendererParams } from "@ag-grid-community/core";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmDialogComponent } from "src/app/components/dialogs/confirm-dialog/confirm-dialog.component";
import { filter } from "rxjs/operators";
import { Subject } from "rxjs";
@Component({
  selector: "app-delete-icon-renderer",
  templateUrl: "./delete-icon-renderer.component.html",
  styleUrls: ["./delete-icon-renderer.component.scss"],
})
export class DeleteIconRendererComponent  implements OnDestroy {
  params: any;
  private destroy$ = new Subject<void>();
  constructor(private dialog: MatDialog) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  btnClickedHandler() {
    if(this.params.isPurchseOrder){
      let deletedRow = this.params.node.data;
      const dialog = this.dialog.open(ConfirmDialogComponent, {
        width: "600px",
        data: {
          title: "Remove Item",
          message: `Are you sure you want to remove ${this.params.node.data.vendorItemName} from this list?`,
        },
      });
      dialog
        .afterClosed()
        .pipe(filter((e) => e === "Confirm"))
        .subscribe((e) => {
          this.params.api.applyTransaction({ remove: [deletedRow] });
          this.params.deleteRow(deletedRow.purchaseOrderItemId);
        }
    );
    } else this.delete()
  }

  delete() {
    this.params.delete(this.params);
  }

  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}

